import { defineMessages } from 'react-intl';

export default defineMessages({
  mainnetOnly: 'This feature is only available on Ethereum Mainnet.',
});
